import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import styles from './section-head.module.css'

const propTypes = {
    className: PropTypes.string,
    headline: PropTypes.node,
    headlineClassName: PropTypes.string,
    subheadline: PropTypes.node,
    subheadlineClassName: PropTypes.string
}

function SectionHead1({ className, headline, headlineClassName, subheadline, subheadlineClassName }) {
    return (
        <div className={cx(styles['section-head-1'], className)}>
            <div className={cx(styles['section-head-1-headline'], headlineClassName)}>{headline}</div>

            <div className={cx(styles['section-head-1-subheadline'], subheadlineClassName)}>{subheadline}</div>
        </div>
    )
}

SectionHead1.propTypes = propTypes

export default SectionHead1
